import { createSlice } from "@reduxjs/toolkit";
import { BreadcrumbInfo } from "../types";
import { translate } from "../common";

export interface BreadcrumbSegment {
    id: string;
    label: string;
}

export interface BreadcrumbState {
    items: BreadcrumbInfo[];
    segments: BreadcrumbSegment[];
}

export const initBreadcrumbState: BreadcrumbState = {
    items: new Array<BreadcrumbInfo>(),
    segments: new Array<BreadcrumbSegment>()
}

const guidRegex = /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/

export const kebabToTranslate = (value: string) => {
    value = value.replace(/-/g, "_").toUpperCase();
    return translate(value)
}

const pathToTitle = (segment: string, segments: BreadcrumbSegment[]) => {
    let value = decodeURI(segment)
    let isGuid = guidRegex.test(value)
    let item = segments.find(x => x.id === value)
    if (!item) {
        if (!isGuid) {
            value = value.replace(/-/g, "_").toUpperCase();
            return translate(value);
        }
        return value;


    } else {
        return item.label;
    }

}

const buildBreadcrumbs = (items: BreadcrumbInfo[], segments: BreadcrumbSegment[]) => {

    let location = window.location.pathname;
    let crumbs = new Array<BreadcrumbInfo>();

    let parts = location.split("/")
    let path = "";
    for (let i = 0; i < parts.length; i++) {
        const segment = parts[i];
        if (segment) {
            path = `${path}/${segment}`;
            if (!segment.match(/([0-9a-zA-Z]{32})/)) {
                let title = pathToTitle(segment, segments);
                if (title) {
                    crumbs.push({
                        path: path,
                        label: title,
                        segment: segment
                    })
                }
            }
        }
    }
    // crumbs.unshift({label: translate("HOME"), path: "/" })
    if (Array.isArray(items)) {
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            let index = crumbs.findIndex(x => x.path === item.path);
            if (index !== -1) {
                if (!crumbs[index].template)
                    crumbs[index] = item;
            }
            else {
                crumbs.push(item);
            }

        }
    }
    return crumbs;
}

const trimLabel = (label: string) => {
    if (label.length > 30) {
        return label.substring(0, 27) + "...";
    }
    return label;
}

const breadcrumbSlice = createSlice({
    name: 'breadcrumbs',
    initialState: initBreadcrumbState,
    reducers: {
        setBreadcrumbSegment(state, action) {
            
            let items = [...state.segments]
            let payload = {...action.payload, label:  trimLabel(action.payload.label) }
            let index = items.findIndex(x => x.id === action.payload.id)
            if (index !== -1) {
                items[index] = payload;
            } else {
                items.push(payload)
            }
            state.items = buildBreadcrumbs([], items);
            state.segments = items;
        },

        setBreadcrumbs(state, action) {



            state.items = buildBreadcrumbs(action.payload, state.segments);
        },
    }
})


export const { setBreadcrumbs, setBreadcrumbSegment } = breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;